// app/javascript/controllers/quiz_polling_controller.js
import { Controller } from "@hotwired/stimulus";
import Noty from "noty";

export default class extends Controller {
  static values = {
    meetingId: Number,
    quizId: Number,
    intervalMs: { type: Number, default: 1000 }
  };

  static targets = ["slider", "start"];

  connect() {
    this.version = null;
    this.timer = null;
    this.backoffStep = 0;
    this.maxBackoffStep = 4;
    this._tick = this._tick.bind(this);
    this._schedule(0);
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer);
    this.timer = null;
  }

  // =========================
  // 내부: 폴링 루프
  // =========================
  _schedule(delay) {
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(this._tick, delay);
  }

  async _tick() {
    try {
      const headers = {};
      if (this.version) headers["If-None-Match"] = this.version;

      const res = await fetch(`/quizzes/${this.quizIdValue}/live_state`, {
        headers
      });

      if (res.status === 304) {
        this.backoffStep = 0;
        this._schedule(this.intervalMsValue);
        return;
      }

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();

      if (data.version && data.version !== this.version) {
        this.version = data.version;
        this.applyLiveState(data);
      }

      this.backoffStep = 0;
      this._schedule(this.intervalMsValue);
    } catch (e) {
      console.warn("quiz-polling: error", e);

      this.backoffStep = Math.min(this.backoffStep + 1, this.maxBackoffStep);
      const delays = [1500, 3000, 6000, 10000, 10000];
      this._schedule(delays[this.backoffStep]);

      new Noty({
        text: this._t("네트워크 일시 오류로 자동 재시도합니다.", "Temporary network issue. Retrying..."),
        type: "warning",
        theme: "bootstrap-v4",
        layout: "topRight",
        timeout: 1500,
      }).show();
    }
  }

  applyLiveState({ action, question_id }) {
    switch (action) {
      case "start":
        this.start({});
        break;
      case "open":
        this.open({ question_id });
        break;
      case "close":
        this.close({ question_id });
        break;
      case "rank":
        this.rank({ question_id });
        break;
      case "final_rank":
        this.final_rank({});
        break;
      default:
        break;
    }
  }


  perform(action, question_id) {
    const controller = this.application.getControllerForElementAndIdentifier(
      this.sliderTarget,
      "quiz-slider"
    );
    if (!controller || !controller.perform) {
      console.warn("quiz-polling: 'quiz-slider' controller not found");
      return;
    }
    controller.perform(action, question_id);
  }

  start() {
    this.perform("start", 0);
  }
  open(payload) {
    this.perform("open", payload.question_id);
  }
  close(payload) {
    this.perform("close", payload.question_id);
  }
  rank(payload) {
    this.perform("rank", payload.question_id);
  }
  final_rank() {
    this.perform("final_rank", 0);
  }

  ready() {
    if (this.hasStartTarget) {
      this.startTarget.textContent = this._t(
        "잠시만 기다려 주세요. 곧 퀴즈가 시작됩니다.",
        "Please hold on a moment. Quiz starts soon."
      );
    }
    this.perform("start", 0);
  }

  fatal() {
    window.location.href = "/";
  }
  error() {
    new Noty({
      text: this._t("뭔가 잘못되었습니다", "Something went wrong"),
      type: "error",
      theme: "bootstrap-v4",
      layout: "topRight",
      timeout: 3000,
    }).show();
  }
  reload() {
    window.location.reload();
  }

  // =========================
  // 유틸
  // =========================
  _t(ko, en) {
    return document.documentElement.lang === "ko" ? ko : en;
  }
}